var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWoundCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.139,
    height: 109.671,
    viewBox: "0 0 123.139 109.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wounded-heart",
    transform: "translate(0 -28.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(0 28.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M112.284,38.863a37.108,37.108,0,0,0-50.71-1.6,37.082,37.082,0,0,0-41.358-5.214A2.4,2.4,0,0,0,22.4,36.335a32.252,32.252,0,0,1,35.954,4.515l-7.3,9.771a2.4,2.4,0,0,0,.551,3.412l5.058,3.527H32.025a13.606,13.606,0,0,0-13.59,13.59v6.488a13.606,13.606,0,0,0,13.59,13.59h22.4l-4.967,8.525a2.4,2.4,0,0,0,.572,3.086l12.608,10.124-3.21,19.474a5.558,5.558,0,0,1-1.807-1.207L14.263,87.873A32.266,32.266,0,0,1,8.337,50.4a2.4,2.4,0,0,0-4.283-2.189,37.075,37.075,0,0,0,6.807,43.068l43.356,43.356a10.415,10.415,0,0,0,14.711,0l43.356-43.356a37.061,37.061,0,0,0,0-52.412ZM23.244,77.638V71.15a8.79,8.79,0,0,1,8.78-8.78H44.519a8.166,8.166,0,0,0-.743,3.408v2.368a2.4,2.4,0,1,0,0,2.877v6.743a2.4,2.4,0,1,0,0,2.877v2.368a8.167,8.167,0,0,0,.743,3.408H32.025a8.791,8.791,0,0,1-8.78-8.781ZM48.586,83.01V65.777a3.412,3.412,0,0,1,3.408-3.408H71.151a3.412,3.412,0,0,1,3.408,3.408V83.01a3.412,3.412,0,0,1-3.408,3.408H51.994A3.412,3.412,0,0,1,48.586,83.01Zm30.783,0V80.64a2.4,2.4,0,1,0,0-2.873V71.021a2.4,2.4,0,1,0,0-2.873v-2.37a8.167,8.167,0,0,0-.743-3.408H91.121a8.79,8.79,0,0,1,8.78,8.78v6.488a8.79,8.79,0,0,1-8.78,8.781H78.626a8.162,8.162,0,0,0,.743-3.408Zm29.514,4.863L65.527,131.229a5.559,5.559,0,0,1-1.174.891l3.257-19.762a2.4,2.4,0,0,0-.867-2.266l-12.089-9.707,5.335-9.157H91.121a13.606,13.606,0,0,0,13.59-13.59V71.149a13.606,13.606,0,0,0-13.59-13.59H65.072L56.4,51.509l6.991-9.355a32.25,32.25,0,0,1,45.5,45.72Z",
    transform: "translate(0 -28.002)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.405,
    cy: 2.405,
    r: 2.405,
    transform: "translate(10.158 10.158)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.405,
    cy: 2.405,
    r: 2.405,
    transform: "translate(29.828 39.177)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.405,
    cy: 2.405,
    r: 2.405,
    transform: "translate(29.828 48.797)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2.405,
    cy: 2.405,
    r: 2.405,
    transform: "translate(88.509 39.177)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2.405,
    cy: 2.405,
    r: 2.405,
    transform: "translate(88.509 48.797)",
    fill: "#003863"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoundCare);
export default __webpack_public_path__ + "static/media/woundCare.97337676.svg";
export { ForwardRef as ReactComponent };